import axios from 'axios';
import Vue from 'vue'

export default {

    findArchivedOrder (page, pageSize, start, end, customersFilter, campaignId, tableNumber ) {
        return axios.get('/api/archived-orders/list', { params: {page: page, pageSize: pageSize, start:start, end:end, customersFilter:customersFilter, campaignId:campaignId, tableNumber:tableNumber  } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrder(id) {  
        return axios.get('/api/archived-orders/details', {params:{id:id}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}

